import { render, staticRenderFns } from "./AppPageNotFound.vue?vue&type=template&id=6474bc34&"
import script from "./AppPageNotFound.vue?vue&type=script&lang=js&"
export * from "./AppPageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports